import React from 'react';
import { Nav, Anchor } from 'grommet';
import { Github, Linkedin, Facebook, Mail } from 'grommet-icons';
import '../styles/hover.css'

const Navigation = () => {

    return (
        <Nav direction="row" pad="medium" justify="center">
            <a><Anchor icon={<Linkedin />} href="https://www.linkedin.com/in/pedropaulotelho/" /></a>
            <a><Anchor icon={<Github />} href="https://github.com/pedromtelho" /></a>
            <a><Anchor icon={<Facebook />} href="https://www.facebook.com/pptelho" /></a>
            <a><Anchor icon={<Mail />} href="mailto:pedropmtelho@gmail.com" /></a>
        </Nav>
    );
}

export default Navigation;